export default __webpack_public_path__ + "static/media/005-rowing.8f1041a3.svg";